import { Flex } from "@chakra-ui/react";
import RecordTargetTag from "features/RecordTarget/RecordTargetTag";
import DisplayResourceTargetsColumn from "features/Resources/SharedTemplate/Components/DisplayResourceTargetsColumn";
import ResourceTargetAvatar from "features/Resources/SharedTemplate/Components/ResourceTargetAvatar";
import useTargetName from "hooks/useTargetName";
import { RecordTarget } from "features/RecordTarget/models";
import { TaskTemplate } from "../models";

function TaskTemplateAssigneeAvatar({ assignee }: { assignee: RecordTarget }) {
  const { name, role } = useTargetName({
    resourceId: assignee.targetId,
    resourceType: assignee.targetType,
  });
  return <ResourceTargetAvatar name={name || ""} roleName={role} />;
}

export function DisplayAssignee({ taskTemplate }: { taskTemplate: TaskTemplate }) {
  if (!taskTemplate?.assignee) {
    return null;
  }
  return (
    <Flex align="center" gap="1">
      <DisplayResourceTargetsColumn<RecordTarget>
        items={[taskTemplate.assignee]}
        renderTag={(assignee: RecordTarget) => (
          <RecordTargetTag key={assignee.targetId} recordTarget={assignee} disabled />
        )}
        renderAvatar={(assignee: RecordTarget) => <TaskTemplateAssigneeAvatar assignee={assignee} />}
        getKey={(assignee: RecordTarget) => assignee.targetId}
        emptyLabel="No Assignee"
      />
    </Flex>
  );
}
